import axios from 'axios'

import {
  INVENTORY_LIST_REQUEST,
  INVENTORY_LIST_FAIL,
  INVENTORY_LIST_SUCCESS,
  INVENTORY_ADD_REQUEST,
  INVENTORY_ADD_FAIL,
  INVENTORY_ADD_SUCCESS,
  INVENTORY_DELETE_REQUEST,
  INVENTORY_DELETE_FAIL,
  INVENTORY_DELETE_SUCCESS,
  INVENTORY_DETAILS_REQUEST,
  INVENTORY_DETAILS_SUCCESS,
  INVENTORY_DETAILS_FAIL,
  INVENTORY_UPDATE_REQUEST,
  INVENTORY_UPDATE_SUCCESS,
  INVENTORY_UPDATE_FAIL,
  INVENTORY_SUMMARY_REQUEST,
  INVENTORY_SUMMARY_SUCCESS,
  INVENTORY_SUMMARY_FAIL,
  MULTI_INVENTORY_UPDATE_REQUEST,
  MULTI_INVENTORY_UPDATE_SUCCESS,
  MULTI_INVENTORY_UPDATE_FAIL
} from '../constants/inventoryConstants'
import { API_URL } from '../apiUrl.js'

export const listInventory =
  (pageNumber = '', wordradio = '') =>
  async (dispatch) => {
    let keyword = wordradio.slice(0, -1)
    let radioValue = wordradio.slice(-1)
    let field

    axios.defaults.withCredentials = true

    try {
      dispatch({ type: INVENTORY_LIST_REQUEST })

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      if (radioValue === '1') {
        field = 'upc'
        const { data } = await axios.get(
          `${API_URL}/inventory/list?pageNumber=${pageNumber}&keyword=${keyword}&field=${field}`,
          config
        )
        dispatch({ type: INVENTORY_LIST_SUCCESS, payload: data })
      } else if (radioValue === '2') {
        field = 'manufacturer'
        const { data } = await axios.get(
          `${API_URL}/inventory/list?pageNumber=${pageNumber}&keyword=${keyword}&field=${field}`,
          config
        )
        dispatch({ type: INVENTORY_LIST_SUCCESS, payload: data })
      } else if (radioValue === '3' || radioValue === '') {
        field = 'subname'
        const { data } = await axios.get(
          `${API_URL}/inventory/list?pageNumber=${pageNumber}&keyword=${keyword}&field=${field}`,
          config
        )
        dispatch({ type: INVENTORY_LIST_SUCCESS, payload: data })
      }
    } catch (err) {
      dispatch({
        type: INVENTORY_LIST_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message
      })
    }
  }

export const addInventory = (item) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: INVENTORY_ADD_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(`${API_URL}/inventory/add`, item, config)

    dispatch({ type: INVENTORY_ADD_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: INVENTORY_ADD_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const deleteInventory = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: INVENTORY_DELETE_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    await axios.delete(`${API_URL}/inventory/del/${id}`, config)
    dispatch({ type: INVENTORY_DELETE_SUCCESS })
  } catch (err) {
    dispatch({
      type: INVENTORY_DELETE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const inventoryDetail = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: INVENTORY_DETAILS_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/inventory/edit/${id}`, config)
    dispatch({ type: INVENTORY_DETAILS_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: INVENTORY_DETAILS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const updateInventory = (unit) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: INVENTORY_UPDATE_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.put(
      `${API_URL}/inventory/upd/${unit._id}`,
      unit,
      config
    )

    dispatch({ type: INVENTORY_UPDATE_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: INVENTORY_UPDATE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const updateInventorymulti =
  (updatearray, objcount) => async (dispatch) => {
    axios.defaults.withCredentials = true

    try {
      dispatch({ type: MULTI_INVENTORY_UPDATE_REQUEST })

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      updatearray.forEach((unit) => {
        const { data } = axios.put(
          `${API_URL}/inventory/updm/${unit._id}?&objcount=${objcount}`,
          unit,
          config
        )

        dispatch({ type: MULTI_INVENTORY_UPDATE_SUCCESS, payload: data })
      })
    } catch (err) {
      dispatch({
        type: MULTI_INVENTORY_UPDATE_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message
      })
    }
  }

export const getunitInventory = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: INVENTORY_DETAILS_REQUEST })
    const { data } = await axios.get(`${API_URL}/inventory/${id}`)

    dispatch({
      type: INVENTORY_DETAILS_SUCCESS,
      payload: data
    })
  } catch (error) {
    dispatch({
      type: INVENTORY_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
    })
  }
}

export const getinventorySummary = () => async (dispatch) => {
  axios.defaults.withCredentials = true

  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }

  try {
    dispatch({ type: INVENTORY_SUMMARY_REQUEST })
    const { data } = await axios.get(`${API_URL}/summary`, config)

    dispatch({
      type: INVENTORY_SUMMARY_SUCCESS,
      payload: data
    })
  } catch (error) {
    dispatch({
      type: INVENTORY_SUMMARY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
    })
  }
}
